module.exports = "<div> <div class=\"u-hide-medium u-hide-large c-tablist__tab-wrapper\"> <a class=\"c-tablist__tab-title c-heading\"> {{ discussionTitle }} </a> <discussion v-if=discussionLoaded :data=discussionData /> </div> <div class=\"u-hide-small c-tablist__title-wrapper c-tablist__title-wrapper--image\"> <div class=\"c-tablist__tab-title c-heading c-tablist__tab-title--active\"> {{ discussionTitle }} </div> <discussion v-if=discussionLoaded :data=discussionData /> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/image/image-page.html
// module id = 121
// module chunks = 1